module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-09-04 at 22.34.48 (1).1e6c30af.jpeg";